import { render, staticRenderFns } from "./BaseFieldText.vue?vue&type=template&id=18d2634b&"
import script from "./BaseFieldText.vue?vue&type=script&lang=ts&"
export * from "./BaseFieldText.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFieldText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports